<template>
    <OtherUserProfile />
</template>

<script>
import OtherUserProfile from '../components/other_user_page/OtherUserProfile.vue';
export default {
    name: 'OtherProfilePage',
    components: {
        OtherUserProfile,
    },
};
</script>
